var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicineorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 133,
    viewBox: "0 0 143 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4627_124874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.4994 122.282C102.125 122.282 126.952 120.833 126.952 119.045C126.952 117.257 102.125 115.807 71.4994 115.807C40.8738 115.807 16.0469 117.257 16.0469 119.045C16.0469 120.833 40.8738 122.282 71.4994 122.282Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.035 109.242H0.0351562V109.314H143.035V109.242Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3269 112.669H14.8047V112.741H31.3269V112.669Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4338 111.116H59.9062V111.187H67.4338V111.116Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8536 111.08H70.1875V111.151H84.8536V111.08Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.767 111.938H109.195V112.009H112.767V111.938Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8579 111.938H82.6094V112.009H96.8579V111.938Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9251 112.669H34.0938V112.741H36.9251V112.669Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.471 111.938H115.102V112.009H127.471V111.938Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8156 15.603H12.5833C12.2357 15.6033 11.8972 15.7144 11.6169 15.9201C11.3366 16.1258 11.1292 16.4155 11.0246 16.747C10.9775 16.896 10.9534 17.0513 10.9531 17.2075V94.8508C10.9531 95.2834 11.1248 95.6983 11.4304 96.0045C11.7361 96.3107 12.1507 96.4831 12.5833 96.4838H67.8156C68.2488 96.4838 68.6641 96.3118 68.9704 96.0055C69.2766 95.6993 69.4487 95.2839 69.4487 94.8508V17.2361C69.4487 16.803 69.2766 16.3876 68.9704 16.0813C68.6641 15.7751 68.2488 15.603 67.8156 15.603ZM69.3772 94.8508C69.3764 95.2647 69.2117 95.6615 68.919 95.9541C68.6263 96.2468 68.2296 96.4116 67.8156 96.4123H12.5833C12.1697 96.4116 11.7732 96.2467 11.481 95.954C11.1888 95.6612 11.0246 95.2644 11.0246 94.8508V17.2218C11.0246 16.8081 11.1888 16.4114 11.481 16.1186C11.7732 15.8258 12.1697 15.661 12.5833 15.6602H67.8156C68.2293 15.6617 68.6256 15.8267 68.9182 16.1193C69.2107 16.4118 69.3757 16.8081 69.3772 17.2218V94.8508Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.68 15.603H74.4534C74.0229 15.6038 73.6102 15.7741 73.3045 16.0771C72.9988 16.3801 72.8248 16.7914 72.8203 17.2218V94.8508C72.8203 95.2839 72.9924 95.6993 73.2986 96.0055C73.6049 96.3118 74.0203 96.4838 74.4534 96.4838H129.68C130.112 96.4823 130.526 96.3096 130.831 96.0035C131.136 95.6974 131.307 95.2829 131.307 94.8508V17.2218C131.304 16.7921 131.131 16.3813 130.826 16.0783C130.521 15.7753 130.11 15.6045 129.68 15.603ZM131.242 94.8508C131.241 95.2647 131.076 95.6615 130.783 95.9541C130.491 96.2468 130.094 96.4116 129.68 96.4123H74.4534C74.0392 96.4123 73.642 96.2478 73.3492 95.955C73.0563 95.6621 72.8918 95.2649 72.8918 94.8508V17.2218C72.8926 16.8079 73.0573 16.4111 73.35 16.1184C73.6427 15.8257 74.0395 15.661 74.4534 15.6602H129.68C130.094 15.6617 130.49 15.8267 130.782 16.1193C131.075 16.4118 131.24 16.8081 131.242 17.2218V94.8508Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.152 29.6566H136.425C136.425 29.6566 134.598 26.3447 130.828 27.3686C130.828 27.3686 131.286 21.8345 128.314 20.9479C125.343 20.0613 123.738 23.4847 123.738 23.4847C123.738 23.4847 121.682 17.0869 117.798 17.8877C113.914 18.6885 112.316 25.3237 112.316 25.3237C112.316 25.3237 106.61 23.2588 106.152 29.6566Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3789 40.4857H92.6634C92.6634 40.4857 90.833 37.1709 87.0636 38.1977C87.0636 38.1977 87.5212 32.6636 84.5496 31.7741C81.5781 30.8846 79.9736 34.3138 79.9736 34.3138C79.9736 34.3138 77.9173 27.916 74.0334 28.7139C70.1495 29.5118 68.5479 36.1499 68.5479 36.1499C68.5479 36.1499 62.8365 34.0878 62.3789 40.4857Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8322 20.0767H11.0586V109.24H61.8322V20.0767Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.37 48.5496H21.1836V109.31H53.37V48.5496Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3335 50.4836H23.5V109.314H51.3335V50.4836Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6709 20.7271H11.0469V16.7631C11.1793 16.4183 11.4155 16.123 11.7229 15.9181C12.0303 15.7132 12.3936 15.6088 12.7629 15.6191H61.8719L61.8948 15.6763L63.1847 19.3571L63.6709 20.7271Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.595 23.1197C15.0497 23.1197 16.2291 22.0479 16.2291 20.7259C16.2291 19.4038 15.0497 18.332 13.595 18.332C12.1402 18.332 10.9609 19.4038 10.9609 20.7259C10.9609 22.0479 12.1402 23.1197 13.595 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8684 23.1197C20.3232 23.1197 21.5025 22.0479 21.5025 20.7259C21.5025 19.4038 20.3232 18.332 18.8684 18.332C17.4137 18.332 16.2344 19.4038 16.2344 20.7259C16.2344 22.0479 17.4137 23.1197 18.8684 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.138 23.1197C25.5927 23.1197 26.772 22.0479 26.772 20.7259C26.772 19.4038 25.5927 18.332 24.138 18.332C22.6832 18.332 21.5039 19.4038 21.5039 20.7259C21.5039 22.0479 22.6832 23.1197 24.138 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4114 23.1197C30.8662 23.1197 32.0455 22.0479 32.0455 20.7259C32.0455 19.4038 30.8662 18.332 29.4114 18.332C27.9567 18.332 26.7773 19.4038 26.7773 20.7259C26.7773 22.0479 27.9567 23.1197 29.4114 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.677 23.1197C36.1318 23.1197 37.3111 22.0479 37.3111 20.7259C37.3111 19.4038 36.1318 18.332 34.677 18.332C33.2223 18.332 32.043 19.4038 32.043 20.7259C32.043 22.0479 33.2223 23.1197 34.677 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9544 23.1197C41.4091 23.1197 42.5884 22.0479 42.5884 20.7259C42.5884 19.4038 41.4091 18.332 39.9544 18.332C38.4996 18.332 37.3203 19.4038 37.3203 20.7259C37.3203 22.0479 38.4996 23.1197 39.9544 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.22 23.1197C46.6747 23.1197 47.8541 22.0479 47.8541 20.7259C47.8541 19.4038 46.6747 18.332 45.22 18.332C43.7652 18.332 42.5859 19.4038 42.5859 20.7259C42.5859 22.0479 43.7652 23.1197 45.22 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4895 23.1197C51.9443 23.1197 53.1236 22.0479 53.1236 20.7259C53.1236 19.4038 51.9443 18.332 50.4895 18.332C49.0348 18.332 47.8555 19.4038 47.8555 20.7259C47.8555 22.0479 49.0348 23.1197 50.4895 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.763 23.1197C57.2177 23.1197 58.397 22.0479 58.397 20.7259C58.397 19.4038 57.2177 18.332 55.763 18.332C54.3082 18.332 53.1289 19.4038 53.1289 20.7259C53.1289 22.0479 54.3082 23.1197 55.763 23.1197Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6684 20.7261C63.6684 22.0474 62.4872 23.1199 61.0315 23.1199C59.5757 23.1199 58.3945 22.0474 58.3945 20.7261C58.3945 19.4048 59.5757 18.3323 61.0315 18.3323C61.443 18.3265 61.8505 18.4143 62.2232 18.5893C62.5958 18.7642 62.9237 19.0215 63.1822 19.3419L63.6684 20.7261Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8322 27.8167H11.0586V28.6518H61.8322V27.8167Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.214 90.3418H61.832V92.1121H101.214V90.3418Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1139 109.237H64.168V81.6408L67.1395 79.1011L70.1139 81.6408V109.237Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6334 109.237H72.6875V81.6408L75.6619 79.1011L78.6334 81.6408V109.237Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.153 109.237H81.207V81.6408L84.1786 79.1011L87.153 81.6408V109.237Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6686 109.237H89.7227V81.6408L92.6971 79.1011L95.6686 81.6408V109.237Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.185 109.237H98.2422V81.6408L101.214 79.1011L104.185 81.6408V109.237Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7505 25.619C42.7505 25.619 42.1985 24.269 38.798 24.6694C35.3975 25.0698 35.0457 29.5715 33.3468 32.7718C31.648 35.9722 29.8433 37.5251 29.8433 37.5251C29.8433 37.5251 29.5945 39.4757 33.2954 40.5768C36.9962 41.6779 44.2492 39.8389 44.2492 39.8389C44.2492 39.8389 45.1872 31.3189 43.7944 28.7192C42.4016 26.1195 42.7505 25.619 42.7505 25.619Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6848 110.724L48.0773 111.01C48.0773 111.01 46.124 93.2553 43.9733 80.3281C43.9733 80.2852 43.9732 80.2366 43.9532 80.1879C43.0723 74.9112 42.16 70.4639 41.3363 68.379C41.3363 68.379 40.2781 84.9298 39.9635 92.2772C39.6489 99.6245 38.1817 112.48 38.1817 112.48L33.9232 113.112C33.9232 113.112 33.2196 87.521 33.6372 82.6876C34.0548 77.8542 32.1529 59.9506 35.4304 55.5176H47.2851C47.2851 55.5176 51.8754 80.6684 52.2072 87.6411C52.5389 94.6138 52.6848 110.724 52.6848 110.724Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1845 112.539L37.1159 113.912L36.9557 117.089L34.5705 117.444L34.5161 114.015L34.4961 112.696L37.1845 112.539Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.669 116.018L49.0006 116.762C49.0006 116.762 48.9377 115.157 48.8748 113.616C48.8348 112.623 48.7947 111.656 48.769 111.162C48.769 110.97 48.7518 110.853 48.7461 110.827L51.6233 110.541V111.445L51.6433 113.487L51.669 116.018Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.918 116.386C37.918 116.386 38.3613 114.61 39.062 114.698C39.7627 114.787 37.918 116.386 37.918 116.386Z",
    stroke: "#0AA0AC",
    strokeWidth: 0.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1172 116.383C38.1172 116.383 39.7846 115.208 40.0934 115.811C40.4023 116.415 38.1172 116.383 38.1172 116.383Z",
    stroke: "#0AA0AC",
    strokeWidth: 0.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6875 116.565C52.6875 116.565 53.0593 114.686 53.4797 114.686C53.9001 114.686 52.6875 116.565 52.6875 116.565Z",
    stroke: "#0AA0AC",
    strokeWidth: 0.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6016 117.147C52.6016 117.147 53.5797 115.223 54.0916 115.637C54.6036 116.052 52.6016 117.147 52.6016 117.147Z",
    stroke: "#0AA0AC",
    strokeWidth: 0.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9988 118.691C39.9988 118.691 34.9137 118.823 34.5448 118.777C34.1759 118.731 33.7669 118.711 33.7383 118.311C33.7383 118.116 33.9127 116.935 33.9413 116.523C33.9699 116.111 33.867 115.897 34.3846 115.765C34.9023 115.634 37.4162 115.342 37.7194 115.654C38.0226 115.966 39.0579 117.152 39.8244 117.29C40.5908 117.427 41.2343 117.373 41.2887 117.807C41.343 118.242 41.3602 118.66 39.9988 118.691Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6409 118.691C54.6409 118.691 49.5587 118.823 49.1869 118.777C48.8151 118.731 48.449 118.62 48.3889 118.434C48.3289 118.248 48.5577 116.935 48.5834 116.523C48.6091 116.111 48.509 115.897 49.0267 115.765C49.5444 115.634 52.0583 115.342 52.3615 115.654C52.6646 115.966 53.6999 117.152 54.4693 117.29C55.2386 117.427 55.8764 117.373 55.9307 117.807C55.9851 118.242 56.0022 118.66 54.6409 118.691Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M43.9606 80.1873C43.0798 74.9106 42.1674 70.4633 41.3438 68.3784L41.89 65.3811C41.89 65.3811 43.3057 76.0775 43.9606 80.1873Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.1845 112.539L37.1159 113.912C36.4466 113.938 35.1139 113.986 34.5161 114.015L34.4961 112.696L37.1845 112.539Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.6496 113.483L48.8754 113.615C48.8353 112.622 48.7953 111.656 48.7695 111.161L51.6295 111.447L51.6496 113.483Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.4727 110.539L53.0465 112.716L47.9672 113.11L47.3008 110.539H53.4727Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8736 111.249L38.4274 113.399L33.125 113.651L33.1279 111.249H38.8736Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5995 48.8731C53.4555 49.4194 50.3095 50.0171 50.3095 50.0171C50.3095 50.0171 48.2503 44.6947 47.7069 41.6688C47.5364 40.587 47.0197 39.5898 46.2344 38.8266C45.449 38.0634 44.4373 37.5754 43.3512 37.436C41.9612 37.2558 36.0925 37.3159 34.0333 37.7391C31.9741 38.1624 31.6166 41.1854 31.4335 43.0015C31.2505 44.8176 30.1036 51.5815 31.0703 53.5835C32.037 55.5855 35.4261 54.7905 35.4261 54.7905V55.5169H47.2837L46.9977 49.9685C46.9977 49.9685 48.1188 52.9143 49.8577 53.0344C51.5965 53.1545 55.5433 50.2545 55.5433 50.2545L54.5995 48.8731ZM33.7215 51.9762C33.7215 51.9762 33.8531 48.5213 34.0876 47.5261L34.4451 49.3708L34.9485 51.9762H33.7215Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2586 51.194L43.1233 48.9375L45.7402 48.5371L46.1406 50.8623L44.1386 51.5944C44.1386 51.5944 43.1748 52.7556 41.25 52.5554L41.2586 51.194Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5938 48.8743L55.5633 47.0954L57.9285 46.1001L58.8237 48.5225L56.8646 49.2861C56.8646 49.2861 56.3526 50.413 55.5633 50.2671L54.5938 48.8743Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3035 35.2706C41.2907 35.4763 41.2907 35.6826 41.3035 35.8883C41.3321 36.2801 41.2577 36.998 42.0271 37.3755C41.6295 38.2335 40.6714 40.3842 40.0909 41.1135C39.2071 40.39 37.1308 37.4699 37.1308 37.4699C37.1308 37.4699 38.5894 35.8883 37.5426 32.9082C37.5426 32.9082 36.0726 31.8328 36.3671 31.2408C36.7046 30.5516 37.6627 30.9234 37.8658 31.2151C37.6513 30.9005 36.6531 27.4485 37.8658 26.1786C38.6208 25.3864 39.3759 25.3778 40.783 25.3206H40.9002C41.8011 25.2892 42.4704 25.3206 42.4704 25.3206C42.7762 25.6501 43.0457 26.0116 43.274 26.3988C43.9122 27.4406 44.3035 28.6146 44.418 29.8308C44.684 32.6651 44.1263 34.9617 41.3035 35.2706Z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0756 31.745C42.0756 31.745 40.7943 32.1797 40.3281 31.2073",
    stroke: "#263238",
    strokeWidth: 0.143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5311 27.6565C40.3168 27.6502 40.1051 27.7042 39.92 27.8124C39.7349 27.9206 39.584 28.0787 39.4844 28.2685",
    stroke: "#263238",
    strokeWidth: 0.286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7917 27.362C43.6878 27.2484 43.5621 27.1569 43.422 27.093C43.282 27.0291 43.1305 26.9942 42.9766 26.9902",
    stroke: "#263238",
    strokeWidth: 0.286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.615 31.2203L42.3633 29.0781L43.6245 30.6969C43.6245 30.6969 43.5016 31.2546 42.615 31.2203Z",
    fill: "#FF5652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.541 29.0936C40.5553 29.3109 40.684 29.4797 40.827 29.4711C40.97 29.4625 41.0701 29.2766 41.053 29.0564C41.0358 28.8361 40.9128 28.6703 40.767 28.6817C40.6211 28.6932 40.5239 28.8848 40.541 29.0936Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0326 28.7349C43.0498 28.9551 43.1756 29.1239 43.3186 29.1124C43.4616 29.101 43.5617 28.9179 43.5446 28.6977C43.5274 28.4775 43.4016 28.3116 43.2586 28.3231C43.1156 28.3345 43.0183 28.5175 43.0326 28.7349Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9977 29.6282C36.9977 29.6282 35.5362 27.6691 36.7432 26.3992C37.4982 25.607 39.5288 25.0894 40.9331 25.0293C40.9016 25.3611 40.9331 28.2668 36.9977 29.6282Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2934 26.4053C42.3955 26.3146 41.5529 25.9295 40.8967 25.3099L40.7852 25.1927C41.3484 25.1694 41.9126 25.2097 42.4668 25.3128C42.7727 25.6423 43.0421 26.0038 43.2705 26.391L43.2934 26.4053Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.311 35.8858C40.6894 35.6968 40.138 35.3275 39.7266 34.8247C40.2192 35.0705 40.7539 35.221 41.3024 35.268C41.2925 35.4739 41.2953 35.6802 41.311 35.8858Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.4434 49.3707L34.0859 47.526V44.8777C34.0859 44.8777 34.4978 47.6719 34.4434 49.3707Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0076 40.8042L66.1602 41.9844L67.0684 58.029L87.9159 56.8489L87.0076 40.8042Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.0076 40.8042L66.1602 41.9844L67.0684 58.029L87.9159 56.8489L87.0076 40.8042Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4256 41.2346L58.5781 42.4148L59.4864 58.4594L80.3339 57.2793L79.4256 41.2346Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.4256 41.2346L58.5781 42.4148L59.4864 58.4594L80.3339 57.2793L79.4256 41.2346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.0049 42.6214L77.5547 42.8884L77.6448 44.3899L82.0949 44.1229L82.0049 42.6214Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.3259 44.0974L59.8828 44.3489L60.0202 46.776L64.4633 46.5245L64.3259 44.0974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M65.8774 50.4287L59.0586 50.8147L59.1658 52.7078L65.9845 52.3218L65.8774 50.4287Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0307 27.5786L91.8867 29.0372C92.2037 29.2585 92.5681 29.4024 92.9506 29.4576L93.0307 27.5786Z",
    fill: "#A02724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.774 117.035L109.451 116.846L108.776 114.012L108.407 112.459L108.27 111.887L110.826 111.712L111.009 111.698L111.553 113.342L112.774 117.035Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6661 117.501C93.729 117.727 90.5802 117.323 90.5802 117.323L90.4686 114.678L90.3828 112.636V112.524H90.4086L93.606 112.842C93.606 112.842 93.606 113.7 93.606 114.675C93.6118 115.928 93.6289 117.378 93.6661 117.501Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.334 35.2489C100.334 35.2489 95.8434 36.4644 96.1752 35.5835C96.3424 35.0504 96.4093 34.4909 96.3725 33.9333C96.3725 33.5672 96.3268 33.307 96.3268 33.307C94.7023 33.4014 93.6098 32.2259 93.1236 30.7787C92.4972 28.9226 92.726 26.8491 93.4868 25.0873C93.5469 24.9443 93.7185 24.338 93.87 24.2637L95.6318 23.4514C95.6318 23.4514 97.3478 24.5754 98.2401 25.2732C99.1324 25.9711 99.8503 29.2143 99.8503 31.7368C99.8503 34.2594 100.334 35.2489 100.334 35.2489Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8959 27.043C92.8165 27.0647 92.7461 27.1109 92.6947 27.1752C92.6433 27.2394 92.6136 27.3183 92.6099 27.4005C92.5981 27.4768 92.6099 27.5549 92.6436 27.6244C92.6774 27.6939 92.7314 27.7514 92.7987 27.7894L92.8959 27.043Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8984 25.5933C93.0853 25.5891 93.2692 25.6398 93.4275 25.7391",
    stroke: "#263238",
    strokeWidth: 0.286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4568 30.2328C94.4568 30.2328 95.761 32.2691 97.8373 32.7353C99.9137 33.2015 100.569 32.4808 100.846 31.3053C101.086 30.197 101.619 29.1731 102.388 28.3395C103.105 27.5988 102.674 25.5882 101.761 23.9351C101.761 23.9351 102.739 23.1143 101.163 22.3249C99.5876 21.5356 99.0071 22.8483 97.64 22.0818C96.2729 21.3153 98.0976 21.0608 96.8077 23.4518C95.5178 25.8427 94.8057 24.1038 94.6141 25.1678C94.4225 26.2317 93.4243 28.0792 94.4568 30.2328Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6133 25.6634C94.4846 25.6205 90.349 24.1247 90.309 23.4469C90.2689 22.7691 93.515 24.0017 93.638 24.0504L94.476 25.3745L94.6133 25.6634Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.964 27.3016C102.924 27.4246 102.678 28.2397 102.572 28.2397L102.226 28.2197C101.904 28.193 101.584 28.1558 101.265 28.1081C100.913 28.0538 100.567 27.9852 100.227 27.9051H100.213C99.8667 27.8221 99.5264 27.7306 99.1946 27.6191C98.3803 27.3732 97.581 27.08 96.8008 26.7411C96.3603 26.5494 95.9714 26.3635 95.6568 26.2034C95.0133 25.8831 94.63 25.6571 94.63 25.6571L94.5728 25.5627L94.3383 25.1938L93.8378 24.4016L93.6662 24.1356V24.1156C93.6581 24.0915 93.6581 24.0654 93.6662 24.0412C93.6834 23.7381 94.304 22.8972 94.4155 22.7542C94.8749 22.1403 95.4599 21.6313 96.1315 21.2613C97.0524 20.7522 98.0906 20.9753 99.0688 21.1469C99.3923 21.2141 99.7078 21.3157 100.01 21.4501L100.201 21.533L100.238 21.5502C100.273 21.5702 100.31 21.5845 100.344 21.6016L100.407 21.6331C101.134 21.9735 101.795 22.4391 102.361 23.0088C103.648 24.4531 103.124 26.8354 102.964 27.3016Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.556 36.7869C101.556 36.7869 101.35 35.3569 100.901 35.0709C100.452 34.7849 95.9902 34.8278 95.2952 35.3169C94.6003 35.8059 94.7232 37.4047 94.7232 37.4047L101.556 36.7869Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6417 27.9753C93.6417 27.9753 94.4025 26.9914 95.2176 27.6006C96.0327 28.2098 95.3863 29.6541 94.4282 30.0602C94.4282 30.0602 93.1898 30.4635 93.0297 29.2022C92.8695 27.9409 93.6417 27.9753 93.6417 27.9753Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5943 62.2144C90.5943 62.2144 88.8926 78.4963 88.4178 85.9838C87.9431 93.4713 89.6877 112.619 89.6877 112.619H93.8261C93.8261 112.619 94.3008 93.5971 95.0158 87.8914C95.7308 82.1857 98.1046 74.4494 98.1046 74.4494C98.1046 74.4494 99.5346 86.6931 100.965 91.6867C102.395 96.6802 107.039 111.935 107.039 111.935L111.804 111.02C111.804 111.02 106.084 91.4493 106.084 85.3861C106.084 79.3229 106.138 67.0821 104.714 62.2201L90.5943 62.2144Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M111.795 111.026L107.034 111.944C107.034 111.944 102.392 96.6888 100.962 91.6952C100.175 88.9496 99.3916 84.0047 98.8454 80.1122C98.3878 76.9347 98.1018 74.458 98.1018 74.458C98.1018 74.458 95.7251 82.18 95.0101 87.9C94.2951 93.62 93.8232 112.628 93.8232 112.628H89.6877C89.6877 112.628 87.9431 93.4827 88.4178 85.9952C88.8926 78.5077 90.5943 62.2229 90.5943 62.2229H104.7C106.13 67.0849 106.073 79.34 106.073 85.3889C106.073 91.4378 111.795 111.026 111.795 111.026Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.8384 80.1123C98.3837 76.9349 98.0977 74.4581 98.0977 74.4581L98.3837 70.0137L98.8384 80.1123Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2383 111.821H94.1975L93.9544 113.863H89.4328L89.2383 111.821Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.434 111.527L111.796 109.533L112.474 112.433L107.24 113.866L106.434 111.527Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.826 111.712L108.406 112.459L108.775 114.012L111.552 113.342L110.826 111.712Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.6068 114.688H90.4608L90.375 112.646L90.395 112.538L93.5925 112.855C93.5925 112.855 93.6011 113.702 93.6068 114.688Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9474 118.517C88.9674 118.571 86.9683 117.407 87.5174 116.864C88.0665 116.321 88.9474 118.517 88.9474 118.517Z",
    stroke: "#0AA0AC",
    strokeWidth: 0.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2286 118.433C89.2143 118.49 88.1132 116.457 88.8625 116.277C89.6119 116.097 89.2286 118.433 89.2286 118.433Z",
    stroke: "#0AA0AC",
    strokeWidth: 0.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.989 117.28C108.989 117.28 108.334 115.172 107.699 115.518C107.064 115.864 108.989 117.28 108.989 117.28Z",
    stroke: "#0AA0AC",
    strokeWidth: 0.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.815 117.462C108.815 117.462 107.337 115.829 106.905 116.401C106.473 116.973 108.815 117.462 108.815 117.462Z",
    stroke: "#0AA0AC",
    strokeWidth: 0.286,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 116.838H109.348C109.348 116.838 107.294 118.073 106.393 118.188C105.493 118.302 104.963 118.357 104.989 119.003C105.015 119.649 105.561 119.706 107.406 119.678C109.251 119.649 112.911 119.875 113.309 119.509C113.706 119.143 113.455 118.454 112.9 116.838Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6663 117.279L90.2343 117.305C90.2343 117.305 88.1809 118.54 87.2828 118.654C86.3848 118.769 85.8528 118.823 85.8757 119.47C85.8986 120.116 86.4477 120.173 88.2953 120.145C90.1428 120.116 93.4004 120.382 93.7979 120.016C94.1954 119.65 93.9752 119.049 93.6663 117.279Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.638 24.0487C93.7266 24.5035 93.8182 24.8524 94.5703 25.6446C93.6151 25.29 90.3433 24.0259 90.3089 23.4453C90.2746 22.8647 92.8143 23.737 93.638 24.0487Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M93.6389 24.1237C93.6308 24.0992 93.6308 24.0728 93.6389 24.0483C93.6389 24.0483 93.6389 24.0802 93.6389 24.1411V24.1237Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M94.6172 25.6635L94.5273 25.6288C94.532 25.6166 94.5378 25.605 94.5447 25.594L94.6172 25.6635Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.964 27.3016C102.924 27.4246 102.678 28.2397 102.572 28.2397L102.226 28.2197C101.904 28.193 101.584 28.1558 101.265 28.1081C100.913 28.0538 100.567 27.9852 100.227 27.9051H100.213C99.8667 27.8221 99.5264 27.7306 99.1946 27.6191C98.3803 27.3732 97.581 27.08 96.8008 26.7411C96.3603 26.5494 95.9714 26.3635 95.6568 26.2034C95.0133 25.8831 94.63 25.6571 94.63 25.6571L94.5728 25.5627L94.3383 25.1938L93.8378 24.4016L93.6662 24.1356V24.1156C93.6581 24.0915 93.6581 24.0654 93.6662 24.0412C93.6834 23.7381 94.304 22.8972 94.4155 22.7542C94.8749 22.1403 95.4599 21.6313 96.1315 21.2613C97.0524 20.7522 98.0906 20.9753 99.0688 21.1469C99.3923 21.2141 99.7078 21.3157 100.01 21.4501L100.201 21.533L100.238 21.5502C100.273 21.5702 100.31 21.5845 100.344 21.6016L100.407 21.6331C101.134 21.9735 101.795 22.4391 102.361 23.0088C103.648 24.4531 103.124 26.8354 102.964 27.3016Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.3309 33.0334C97.0265 33.3502 96.7057 33.6509 96.37 33.9343C96.37 33.5683 96.3242 33.308 96.3242 33.308C96.6692 33.2555 97.007 33.1633 97.3309 33.0334Z",
    fill: "#232323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5882 62.3733V47.7244L87.9141 46.6347C87.9141 46.6347 88.426 38.8183 92.2327 37.5857C96.0393 36.353 102.815 35.8353 104.679 37.5857C105.858 38.6982 106.015 40.4828 106.058 42.0129C106.149 45.1303 105.334 48.1791 105.154 51.2793C105.011 53.8019 104.925 56.3244 104.868 58.8498C104.868 59.0442 104.794 62.3733 104.788 62.3733H90.5882Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.053 48.2259C92.053 48.2259 90.0739 54.7638 88.1177 55.1728C86.1614 55.5818 79.4805 51.9353 79.4805 51.9353H76.4975L76.0742 49.3127C76.0742 49.3127 78.8513 48.2831 80.7017 49.5157C80.7017 49.5157 85.0232 51.4005 86.4617 51.9496L88.5467 46.9045L92.053 48.2259Z",
    fill: "#B55B52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5194 53.3117C67.6042 52.7139 66.5362 50.6766 67.1341 48.7613C67.7319 46.8461 69.7692 45.7781 71.6845 46.376C73.5997 46.9738 74.6677 49.0111 74.0698 50.9264C73.472 52.8416 71.4347 53.9096 69.5194 53.3117Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.499 49.4897L70.0535 49.3853L69.9517 47.8582L71.1536 47.7784L71.2554 49.3055L72.9652 49.1905L73.0461 50.3784L71.3343 50.4925L71.4357 52.0063L70.2339 52.0861L70.1324 50.5724L68.5779 50.6768L68.499 49.4897Z",
    fill: "#189FAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4627_124874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143,
    height: 143,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicineorder);
export default __webpack_public_path__ + "static/media/Medicineorder.325f824e338d9e60df0162a9f6fed211.svg";
export { ForwardRef as ReactComponent };